module.exports = "/images/fga_logo_white.png?26ba6368b519d1fca05210588147f4cc";